import { Box, ListSubheader, MenuItem, Typography } from '@material-ui/core'
import { Controller, FieldErrors } from 'react-hook-form'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import { Textarea } from '@/components/textarea'
import { routes } from '@/routes/config'

import { StepKeys } from '../..'
import { useNewActivityForm } from '../../new-activity-form'
import { PulverizationActivityForm } from '../../new-activity-form-schema'
import { useStyles } from './styles'

export interface ActivityTypeStepProps {
  onChangeCurrentStep: (step: StepKeys) => void
}

export function ActivityTypeStep({
  onChangeCurrentStep,
}: ActivityTypeStepProps) {
  const classes = useStyles()
  const { register, watch, trigger, formState, control } = useNewActivityForm()

  const pulverizationErrors =
    formState.errors as FieldErrors<PulverizationActivityForm>

  const activityType = watch('activity_type')

  async function handleNextStep() {
    const isValid = await trigger(['activity_type', 'date', 'description'], {
      shouldFocus: true,
    })

    if (!isValid) return

    activityType === 'mapping'
      ? onChangeCurrentStep('mapping_info')
      : onChangeCurrentStep('pulverization_info')
  }

  return (
    <div className={classes.container}>
      <Typography variant='h1'>Nova atividade</Typography>

      <div className={classes.inputsContainer}>
        <Controller
          control={control}
          name='activity_type'
          render={({ field, fieldState }) => (
            <InputText
              id='activity_type'
              select
              required
              label={'Selecione a atividade'}
              SelectProps={{
                MenuProps: {
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                  classes: { list: classes.menuList },
                },
              }}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              {...field}
            >
              <ListSubheader value=''>Atividades</ListSubheader>
              <MenuItem value={'mapping'}>Mapeamento da área</MenuItem>
              <MenuItem value={'pulverization'}>Pulverização</MenuItem>
            </InputText>
          )}
        />

        {(activityType === 'mapping' || !activityType) && (
          <InputText
            id='date'
            type='date'
            label='Data prevista para a atividade'
            required
            InputLabelProps={{ shrink: true }}
            onKeyDown={(e) => e.preventDefault()}
            error={!!formState.errors.date}
            helperText={formState.errors.date?.message}
            {...register('date')}
          />
        )}

        {activityType === 'pulverization' && (
          <Box display={'flex'} gridGap={'1rem'}>
            <InputText
              id='start_date'
              type='date'
              label='Data inicial prevista para a atividade'
              required
              InputLabelProps={{ shrink: true }}
              onKeyDown={(e) => e.preventDefault()}
              error={!!pulverizationErrors.date?.start_date}
              helperText={pulverizationErrors.date?.start_date?.message}
              {...register('date.start_date')}
            />
            <InputText
              id='end_date'
              type='date'
              InputLabelProps={{ shrink: true }}
              onKeyDown={(e) => e.preventDefault()}
              label='Data final prevista para a atividade'
              error={!!pulverizationErrors.date?.end_date}
              helperText={pulverizationErrors.date?.end_date?.message}
              {...register('date.end_date')}
            />
          </Box>
        )}

        <Controller
          control={control}
          name='description'
          defaultValue=''
          render={({ field, fieldState: { error } }) => {
            return (
              <Textarea
                aria-label='Descrição da atividade'
                placeholder='Deixe anotações sobre a atividade'
                value={field.value}
                error={error?.message}
                onChange={field.onChange}
              />
            )
          }}
        />

        <div className={classes.buttonsContainer}>
          <Button outlined component={Link} to={routes.Activities()}>
            Cancelar
          </Button>
          <Button onClick={handleNextStep}>Avançar</Button>
        </div>
      </div>
    </div>
  )
}
